import { useState } from "react";
import { Link } from "react-router-dom";
import { articles, categories, getArticlesByCategory } from "@/mocks/news";
import ArticleCard from "@/components/feature/ArticleCard";
import TrendingPanel from "@/components/feature/TrendingPanel";

export default function CategoryFeed() {
  const [activeSlug, setActiveSlug] = useState(categories[0].slug);

  const catArticles = getArticlesByCategory(activeSlug);
  const fillers = articles.filter((a) => !catArticles.some((c) => c.id === a.id));
  const shown = catArticles.concat(fillers).slice(0, 4);

  const activeCat = categories.find((c) => c.slug === activeSlug)!;

  return (
    <section className="bg-background-50 border-y border-background-200/70 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between gap-4 mb-6">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-1.5 h-6 rounded-full bg-primary-500 inline-block"></span>
              <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">栏目精选</h2>
              <span className="hidden sm:block text-sm text-foreground-400">{activeCat.name} · 最新爆料抢先看</span>
            </div>
          </div>
          <Link
            to={`/category/${activeSlug}`}
            className="inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-600 font-medium whitespace-nowrap"
          >
            进入{activeCat.name}栏目<i className="ri-arrow-right-s-line text-lg"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            {/* 分类标签 */}
            <div className="flex items-center gap-2 flex-wrap mb-6">
              {categories.map((c) => (
                <button
                  key={c.slug}
                  type="button"
                  onClick={() => setActiveSlug(c.slug)}
                  className={`px-4 py-1.5 text-sm rounded-full transition-colors whitespace-nowrap ${
                    activeSlug === c.slug
                      ? "bg-primary-600 text-background-50 font-medium"
                      : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
                  }`}
                >
                  {c.name}
                </button>
              ))}
            </div>

            {/* 栏目内容 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {shown.map((a) => (
                <ArticleCard key={a.id} article={a} />
              ))}
            </div>
          </div>

          {/* 右侧热搜/快讯 */}
          <TrendingPanel />
        </div>
      </div>
    </section>
  );
}